import { render } from "./svg-icon.html?vue&type=template&id=11b2bca1&scoped=true&ts=true"
import script from "./svg-icon.ts?vue&type=script&lang=ts"
export * from "./svg-icon.ts?vue&type=script&lang=ts"

import "./svg-icon.scss?vue&type=style&index=0&id=11b2bca1&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b2bca1"]])

export default __exports__